var _rect, _rect2, _g, _use, _use2, _use3, _circle, _path, _use4, _use5, _use6, _use7, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _use8, _circle2, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagOfArgentina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    fill: "#74acdf",
    height: 500
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 166.67,
    width: 800,
    fill: "#fff",
    height: 166.67
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rays"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ray1",
    strokeWidth: 1.1116,
    stroke: "#85340a",
    fill: "#f6b40e",
    d: "m396.84 251.31l28.454 61.992s0.4896 1.185 1.28 0.8586c0.7902-0.3267 0.2988-1.5116 0.2988-1.5116l-23.715-63.956m-0.68 24.12c-0.3465 9.4278 5.4526 14.613 4.6943 23.032-0.7569 8.42 3.8673 13.18 4.9396 16.454 1.0733 3.2744-1.16 5.2323-0.198 5.6982 0.96336 0.4662 3.07-2.1207 2.3833-6.7756-0.68675-4.6549-4.2204-6.0368-3.3898-16.32 0.83-10.283-4.206-12.678-2.98-22.058"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ray1",
    transform: "rotate(22.5 400,250)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ray1",
    transform: "rotate(45 400,250)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ray1",
    transform: "rotate(67.5 400,250)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ray2",
    fill: "#85340a",
    d: "m404.31 274.41c0.45334 9.0538 5.5867 13.063 4.5787 21.314 2.2133-6.5249-3.1233-11.583-2.82-21.22m-7.6487-23.757l19.487 42.577-16.329-43.887"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ray2",
    transform: "rotate(22.5 400,250)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ray2",
    transform: "rotate(45 400,250)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ray2",
    transform: "rotate(67.5 400,250)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays",
    transform: "rotate(90 400,250)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays",
    transform: "rotate(180 400,250)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rays",
    transform: "rotate(270 400,250)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 27.778,
    stroke: "#85340a",
    cy: 250,
    cx: 400,
    strokeWidth: 1.5,
    fill: "#f6b40e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "loweyecontour",
    fill: "#843511",
    d: "m409.47 244.06c-1.8967 0.00003-3.7131 0.82183-4.7812 2.5312 2.1367 1.9227 6.8565 2.1318 10.062-0.21875-1.3883-1.4954-3.3845-2.3125-5.2812-2.3125zm-0.0312 0.4375c1.8462-0.0335 3.5717 0.81446 3.8125 1.6562-2.1367 2.3504-5.5508 2.1463-7.6875 0.4375 0.9348-1.4957 2.4391-2.0677 3.875-2.0938z"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uppalpebra",
    transform: "matrix(-1 0 0 1 800.25 0)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eyebrow_nose",
    transform: "matrix(-1 0 0 1 800.25 0)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pupil",
    transform: "translate(18.862)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lowpalpebra",
    transform: "matrix(-1 0 0 1 800.25 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m395.75 253.84c-0.91341 0.16668-1.5625 0.97727-1.5625 1.9062 0 1.0614 0.87748 1.9062 1.9375 1.9062 0.62667 0 1.2025-0.2968 1.5625-0.8125 0.73952 0.55614 1.7646 0.61511 2.3125 0.625 0.0843 0.002 0.19312 0 0.25 0 0.54791-0.01 1.573-0.0689 2.3125-0.625 0.36 0.5157 0.93583 0.8125 1.5625 0.8125 1.06 0 1.9375-0.84488 1.9375-1.9062 0-0.92898-0.64918-1.7396-1.5625-1.9062 0.513 0.1809 0.84375 0.6765 0.84375 1.2188 0 0.7074-0.57124 1.2812-1.2812 1.2812-0.6804 0-1.2413-0.54015-1.2812-1.2188-0.20862 0.41637-1.0341 1.6551-2.6562 1.7188-1.6222-0.0636-2.4476-1.3024-2.6562-1.7188-0.04 0.6786-0.60085 1.2188-1.2812 1.2188-0.71001 0-1.2812-0.57385-1.2812-1.2812 0-0.54225 0.33075-1.0378 0.84375-1.2188z",
    fill: "#85340a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m397.84 259.53c-2.138 0-2.9829 1.9368-4.9062 3.2188 1.0687-0.42633 1.9096-1.2693 3.4062-2.125 1.496-0.85442 2.7717 0.1875 3.625 0.1875h0.0312c0.8532 0 2.129-1.0416 3.625-0.1875 1.4967 0.8559 2.3688 1.6987 3.4375 2.125-1.9233-1.282-2.7996-3.2188-4.9375-3.2188-0.4266 0-1.2716 0.23055-2.125 0.65625h-0.0312c-0.85334-0.42642-1.6983-0.65625-2.125-0.65625z",
    fill: "#85340a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m397.12 262.06c-0.8439 0.0374-1.9596 0.20675-3.5625 0.6875 3.8473-0.85434 4.6962 0.4375 6.4062 0.4375h0.0312c1.71 0 2.5588-1.292 6.4062-0.4375-4.2744-1.282-5.1242-0.4375-6.4062-0.4375h-0.0312c-0.80125 0-1.4372-0.3124-2.8438-0.25z",
    fill: "#85340a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m393.75 262.72c-0.24819 0.003-0.51871 0.005-0.8125 0.0312 4.488 0.42766 2.3306 3 7.0312 3h0.0312c4.7007 0 2.5745-2.5724 7.0625-3-4.7007-0.4266-3.2146 2.3438-7.0625 2.3438h-0.0312c-3.6075 0-2.4959-2.4215-6.2188-2.375z",
    fill: "#85340a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m403.85 269.66c0-2.1234-1.7233-3.8465-3.8463-3.8465-2.1233 0-3.8463 1.723-3.8463 3.8465 0.423-1.781 2.0166-3.0393 3.8463-3.0393 1.8333 0 3.424 1.2586 3.8463 3.0393v0 0z",
    fill: "#85340a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "eyebrow_nose",
    fill: "#85340a",
    d: "m382.73 244.02c4.9146-4.2729 11.11-4.9147 14.53-1.7086 0.837 1.1207 1.3733 2.319 1.5934 3.5696 0.4302 2.433-0.3303 5.0617-2.2367 7.7559 0.2151-0.001 0.6435 0.2124 0.8568 0.4266 1.6967-3.244 2.2967-6.5761 1.74-9.7454-0.1458-0.828-0.3735-1.643-0.6696-2.4357-4.7007-3.8452-11.11-4.2729-15.811 2.1377z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "uppalpebra",
    fill: "#85340a",
    d: "m390.42 242.74c2.7767 0 3.4186 0.6417 4.7007 1.71 1.2833 1.0683 1.9233 0.8541 2.1367 1.0683 0.2124 0.2142 0 0.8541-0.4266 0.6399s-1.2833-0.6399-2.5633-1.7086c-1.2833-1.0696-2.5633-1.0683-3.8463-1.0683-3.8463 0-5.983 3.2046-6.4094 2.9907-0.4266-0.2142 2.1367-3.6325 6.4094-3.6325z"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#loweyecontour",
    transform: "translate(-19.181)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "pupil",
    cy: 246.15,
    cx: 390.54,
    r: 1.923,
    fill: "#85340a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "lowpalpebra",
    fill: "#85340a",
    d: "m385.29 247.44c3.6327 2.7783 7.265 2.5644 9.4017 1.282 2.1367-1.282 2.1367-1.7086 1.71-1.7086-0.4266 0-0.8532 0.4266-2.5633 1.281-1.71 0.8559-4.273 0.8559-8.546-0.8541z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfArgentina);
export default __webpack_public_path__ + "static/media/Flag_of_Argentina.f79ee67af3762f52c41f7216313bafc4.svg";
export { ForwardRef as ReactComponent };